import { render } from "./DeliveryApp.vue?vue&type=template&id=7fcf1bdf"
import script from "./DeliveryApp.vue?vue&type=script&lang=js"
export * from "./DeliveryApp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__